/* globals lp */
var jQuery = require('jquery');

var ubBanzai = window.ubBanzai;

;(function(){

  var pushSamplesToSns = function(data) {
    var page = window.editor.page
      , postData = {
          userAgent      : navigator.userAgent,
          variantId      : page.id,
          samples        : data,
          undoCount      : page.undoManager.undoCount,
          elemCount      : page.elements.length,
          visibleElCount : page.getVisibleElements().length,
          sessionUUID    : lp.getSessionId()
      };

    var eventsGatewayHostname = ubBanzai.getFeatureValue('eventsGatewayHostname');
    var eventsGatewayEndpoint = "https://" + eventsGatewayHostname + "/events/event_tracking?subject=perf_samples";

    jQuery.ajax({
      type: "POST"
      , url: eventsGatewayEndpoint
      , contentType: "application/json; charset=utf-8"
      , dataType: "json"
      , data: JSON.stringify(postData)
      , success: null // fire and forget for now
    });
  };

  var onError = function(error) {
    console.log(error);
  };

  if(ubBanzai.features.isPerfSamplingEnabled()) {
    lp.PerfSampling
      .bufferedSamplesObs
      .filter(function(e){
        return e.length > 0;
      })
      .subscribe(pushSamplesToSns, onError);
  }
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/performance/perf_send_to_sns.js
// module id = 1072
// module chunks = 0